<template>
  <b-modal
    id="identity-to-submit-modal"
    class="identity-to-submit-full-screen-modal"
    header-class="identity-to-submit-modal-header"
    ref="modal"
    centered
    scrollable
    :no-close-on-esc="noClose"
    :no-close-on-backdrop="noClose"
  >

    <template #modal-header="{ close }">
      <div  class="identity-to-submit-modal-header-content step4 w-100">
        <img :src="require(`@/assets/images/b122/ic_investigator_binoculars.png`)" class="identity-to-submit-modal-img" >
      </div>
    </template>

    <div>

      <div class="page-title mb-4">
        {{ $t('identity.to.submit.title')}}
      </div>

      <div class="first-connexion-identity-info">
        <span>{{ $t('validate_identity_info_1') }}</span>
        <span class="first-connexion-identity-info-highlight">{{ $t('validate_identity_info_2') }}</span>
      </div>

      <p class="modal-annonce-text mt-2" v-html="$t('identity.to.submit.details.part1')"></p>

      <p class="modal-annonce-text" v-html="$t('identity.to.submit.details.part2')"></p>
    </div>


    <template #modal-footer="{ ok, cancel, hide }">
      <div class="w-100 d-flex">
        <b-button  class="w-100 mr-2" variant="primary"  @click="handleOk($event)">
          <div class="d-flex justify-content-center align-items-center">
            <span class="align-self-center mt-small-px">{{$t('identity.to.submit.button')}}</span>
            <i class="ph-custom ph-caret-circle-right-bold ml-3" size="24"/>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    noClose: {
      type:Boolean,
      default: false
    }
  },

  methods: {

    handleOk(e) {
      this.$router.push({name: 'ProfileEdit'})
      this.$bvModal.hide('identity-to-submit-modal')
    },
  },
};
</script>

<!-- not scoped car modal --><style>

#identity-to-submit-modal {
  z-index: 10020;
}

#identity-to-submit-modal__BV_modal_backdrop_ {
  z-index: 10010;
}

#identity-to-submit-modal .modal-header{
  background-color: var(--main-black-light) !important;
  padding-bottom: 0px;
}

#identity-to-submit-modal .modal-content,
#identity-to-submit-modal .modal-body,
#identity-to-submit-modal .modal-footer{
  background-color: var(--main-black-dark);
}

.identity-to-submit-modal-subtitle{
  font-size: 24px;
}

.identity-to-submit-modal-img{
  max-width: 200px;
}
#identity-to-submit-modal .identity-to-submit-modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: none;
}


.identity-to-submit-modal-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

#identity-to-submit-modal .modal-annonce-text{
  color: var(--main-white);
}

.identity-to-submit-modal-header {
  background-color: var(--main-black-medium) !important;
  position: relative;
  margin-top: -20px;
  margin-right: -20px;
  margin-left: -20px;
}

.identity-to-submit-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

.first-connexion-identity-info {
  width: 100%;
  margin-bottom: 16px;
  padding: 12px;
  border-radius: 10px;
  background-color: #FEF9A5;
  color: #000000;
  text-align: left;
  line-height: 1.4;
}

.first-connexion-identity-info-highlight {
  color: #CF802D;
  font-weight: 700;
  text-decoration: underline;
}

@media (min-width: 992px) {
  .identity-to-submit-container {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  .identity-to-submit-container img {
    order: 2;
    align-self: center;
  }
  .identity-to-submit-container {
    text-align: center;
  }
}

#identity-to-submit-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
  max-height: calc(100vh - 16px);
}

.identity-to-submit-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
  min-height: calc(100vh - 16px);
}

.identity-to-submit-full-screen-modal .modal-dialog.modal-dialog-centered {
  align-items: flex-start;
  justify-content: flex-start;
}
.identity-to-submit-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #identity-to-submit-modal .modal-content {
    display: flex;
    overflow: auto;
  }
  #identity-to-submit-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #identity-to-submit-modal .modal-body{
    display: block;
  }

  #identity-to-submit-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #identity-to-submit-modal .modal-header {
    padding-top: 0px;
  }
  .identity-to-submit-modal-img {
    margin-top: 20px;
    align-self: end;
  }
  .identity-to-submit-modal-subtitle {
    margin-top: 6px !important;
    margin-left: 0px !important;
  }
  #identity-to-submit-modal .modal-content {
    margin: 8px;
  }
  #identity-to-submit-modal .modal-annonce-text, #identity-to-submit-modal .identity-to-submit-container {
    padding: 10px;
  }
  #identity-to-submit-modal .identity-to-submit-modal-img {
    max-width: 100px;
  }
}

@media (max-height: 852px) {
  #identity-to-submit-modal .modal-content {
    overflow: auto;
  }
  .title-step4{
    font-size: 24px!important;
  }

  .identity-to-submit-modal-subtitle{
    font-size: 18px;
  }
  .identity-to-submit-modal-header-content, #identity-to-submit-modal .modal-annonce-text, .identity-to-submit-container {
    padding: 2px;

  }
}





</style>



// WEBPACK FOOTER //
// src/views/user/IdentityToSubmitModal.vue